var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconGraphQl = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.072 10.656H3.92m8.3.723L8.93 13.374M2.844 9.719a1.094 1.094 0 1 1 0 2.187 1.094 1.094 0 0 1 0-2.187m0 0v-3.44m10.312 3.44a1.094 1.094 0 1 1 0 2.187 1.094 1.094 0 0 1 0-2.187m0 0v-3.44M7.593 3.072 3.547 9.988m4.86-6.916 4.046 6.916M7.064 2.63 3.778 4.621m0 6.758 3.292 1.995M8.936 2.629l3.286 1.992M8 3.156A1.094 1.094 0 1 0 8 .97a1.094 1.094 0 0 0 0 2.187M2.844 6.281a1.094 1.094 0 1 0 0-2.187 1.094 1.094 0 0 0 0 2.187m10.312 0a1.094 1.094 0 1 0 0-2.187 1.094 1.094 0 0 0 0 2.187M8 15.031a1.094 1.094 0 1 0 0-2.187 1.094 1.094 0 0 0 0 2.187"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.072 10.656H3.92m8.3.723L8.93 13.374M2.844 9.719a1.094 1.094 0 1 1 0 2.187 1.094 1.094 0 0 1 0-2.187m0 0v-3.44m10.312 3.44a1.094 1.094 0 1 1 0 2.187 1.094 1.094 0 0 1 0-2.187m0 0v-3.44M7.593 3.072 3.547 9.988m4.86-6.916 4.046 6.916M7.064 2.63 3.778 4.621m0 6.758 3.292 1.995M8.936 2.629l3.286 1.992M8 3.156A1.094 1.094 0 1 0 8 .97a1.094 1.094 0 0 0 0 2.187M2.844 6.281a1.094 1.094 0 1 0 0-2.187 1.094 1.094 0 0 0 0 2.187m10.312 0a1.094 1.094 0 1 0 0-2.187 1.094 1.094 0 0 0 0 2.187M8 15.031a1.094 1.094 0 1 0 0-2.187 1.094 1.094 0 0 0 0 2.187"
  }));
});
export default SvgIconGraphQl;
export const raw = __webpack_public_path__ + "static/media/IconGraphQL.9220d565d68fd2a749c56f10fafee3aa.svg";